import type { PropsWithChildren } from 'react';

type FormControlProps = {
  label: string;
};
export const FormControl = ({ label, children }: PropsWithChildren<FormControlProps>) => {
  return (
    <label>
      {/* TODO 1335 missing TBIT DS token for spacing */}
      <span className="mb-1 tds-input-label">{label}</span>
      {children}
    </label>
  );

};
